'use strict';

module.exports = function (data, e) {

  if (!e) return;
  console.log(e);

  console.log(data);

  var ix = data.refToEdit.indexOf('C');
  var index = data.refToEdit.substring(1, ix);

  console.log(ix);
  console.log(index);

  this.data[index][data.column] = e.target.value;

  this.cancelCellEdit(data.refToEdit);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/set-cell-value.js